import React from "react";

// import appeal from '../../data/appeal'

// import DonationContext from '../../context/donation'

const Loading: React.FC = () => {

  // const donation = useContext(DonationContext)

  return (
    <>
      <div id="loading">
        <div className="disc">
          <img src="/assets/default/images/loader.gif" alt="Royal Botanic Gardens, Kew"/>
        </div>
      </div>
    </>
  );
};

export default Loading;